// BosAI widget — how to read a case/escalate response.
//
// The widget may only tell the visitor "your case is open / passed to a
// specialist" when the API returned 2xx AND a case id. Anything else (5xx, 429,
// a 2xx without an id, a non-JSON body) is an honest failure the visitor can
// retry. email_required / email_invalid keep their existing re-ask behavior.

// A case/escalate request that hangs is aborted after this long, which lands in
// the widget's catch -> "NOT opened" + Try again (never a stuck spinner).
export const CASE_REQUEST_TIMEOUT_MS = 20000;

export type CaseOutcome =
  | { kind: "ok"; caseId: string; ref: string | null; emailed: boolean }
  | { kind: "needEmail"; invalid: boolean }
  | { kind: "error"; rateLimited: boolean };

type CaseBody = {
  error?: unknown;
  caseId?: unknown;
  caseRef?: unknown;
  ticketCode?: unknown;
  emailed?: unknown;
};

const str = (v: unknown): string | null => (typeof v === "string" && v.trim() ? v.trim() : null);

export function readCaseOutcome(status: number, body: unknown): CaseOutcome {
  const d: CaseBody = body && typeof body === "object" ? (body as CaseBody) : {};
  if (status === 400 && (d.error === "email_required" || d.error === "email_invalid")) {
    return { kind: "needEmail", invalid: d.error === "email_invalid" };
  }
  const caseId = str(d.caseId);
  if (status >= 200 && status < 300 && caseId) {
    return { kind: "ok", caseId, ref: str(d.caseRef) ?? str(d.ticketCode), emailed: d.emailed === true };
  }
  return { kind: "error", rateLimited: status === 429 };
}
